exports = module.exports = require("../../../../node_modules/.pnpm/css-loader@2.1.0_webpack@4.14.0/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.icon[data-v-56cf002c] {\r\n  width: 1em;\r\n  height: 1em;\r\n  vertical-align: -0.15em;\r\n  fill: currentColor;\r\n  overflow: hidden;\n}\r\n", ""]);

